import * as React from "react"

const About = () => (
  <section id="about" className="services section-padding">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-title-header text-center">
            <h1 className="section-title wow fadeInUp" data-wow-delay="0.2s">About</h1>
            <p className="wow fadeInDown" data-wow-delay="0.2s">このカンファレンスについて</p>
          </div>
        </div>
      </div>
      <div className="row services-wrapper">
        <div className="col-md-6 col-xs-12 padding-none services-item">
          <div className="wow fadeInDown" data-wow-delay="0.2s">
            <div className="icon">
              <i className="lni-users"></i>
            </div>
            <div className="services-content">
              <h3>SRE NEXTとは</h3>
              <p>
                信頼性に関するプラクティスに深い関心を持つエンジニアのためのカンファレンスです。<br />
                同じくコミュニティベースのSRE勉強会である<a href="https://sre-lounge.connpass.com/" target="_blank" rel="noreferrer">「SRE Lounge」</a>のメンバーが中心となり運営・開催されます。
                SRE NEXT 2022は「SRE DIVERSITY」をテーマとして掲げ、スタートアップから大企業まで幅広い業種・領域・フェーズでのSRE Practiceの実践を集約し、より多様なSREの実践が普及することを目指します。
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xs-12 padding-none services-item">
          <div className="wow fadeInDown" data-wow-delay="0.2s">
            <div className="icon">
              <i className="lni-notepad"></i>
            </div>
            <div className="services-content">
              <h3>SREとは</h3>
              <p>
                Googleにより提唱された、システム管理とサービス運用における考え方または方法論であり、それらを実践するエンジニアを指します。
                SREは、サービスやインフラの信頼性をソフトウェアエンジニアリングによって実現することを目指します。 サービスの信頼性を重視する多くの企業において取り入れられており、近年ますますその広がりを見せています。
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xs-12 padding-none services-item">
          <div className="wow fadeInDown" data-wow-delay="0.4s">
            <div className="icon">
              <i className="lni-gallery"></i>
            </div>
            <div className="services-content">
              <h3>セッションに<wbr />ついて</h3>
              <p>
                招待・公募を含め、幅広い企業の第一線で活躍されている方々をお招きし、現場における生の課題や解決策が垣間見えるセッションを多く揃えます。
                SREの取り組みには決められた正解がないため、各社のエンジニアはときに手探りで実践しています。そのようなノウハウが一堂に集まる本カンファレンスはSREを実践する多くのエンジニアにとって有益なものになると信じています。<br />
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xs-12 padding-none services-item">
          <div className="wow fadeInDown" data-wow-delay="0.6s">
            <div className="icon">
              <i className="lni-handshake"></i>
            </div>
            <div className="services-content">
              <h3>スポンサーに<wbr />ついて</h3>
              <p>
                SRE NEXT 2022におけるスポンサー募集は2/28をもって終了しました。
              </p>
              <ul>
                <li>
                  <a href="https://docs.google.com/document/d/1dMU1OtGiWgKjAXRddDm5wwUK5dCDnWz_6DEuvhvCIic/edit" target="_blank" rel="noreferrer">
                    スポンサー募集要項
                  </a>
                </li>
              </ul>
              <p>
                お申し込み済みのスポンサー様における疑問点やご相談は、お気軽に sre.next<span className="atmark" />gmail.com までお問い合わせください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default About
